import Characteristics from "./Characteristics";
import CharacteristicsTitle from "./title";
import CharacteristicsItems from "./characteristic-items";
 
export default Characteristics;

export { CharacteristicsTitle, CharacteristicsItems };
